<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="80"
    >
      <FormItem label="权限名称" prop="name">
        <Input v-model="formValidate.name" placeholder="请输入权限名称"></Input>
      </FormItem>
      <FormItem label="权限代码" prop="value">
        <Input
          v-model="formValidate.value"
          placeholder="请输入权限代码"
        ></Input>
      </FormItem>
      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>
    <!-- <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
        <FormItem label="Name" prop="name">
            <Input v-model="formValidate.name" placeholder="Enter your name"></Input>
        </FormItem>
        <FormItem label="E-mail" prop="mail">
            <Input v-model="formValidate.mail" placeholder="Enter your e-mail"></Input>
        </FormItem>
        <FormItem label="City" prop="city">
            <Select v-model="formValidate.city" placeholder="Select your city">
                <Option value="beijing">New York</Option>
                <Option value="shanghai">London</Option>
                <Option value="shenzhen">Sydney</Option>
            </Select>
        </FormItem>
        <FormItem label="Date">
            <Row>
                <Col span="11">
                    <FormItem prop="date">
                        <DatePicker type="date" placeholder="Select date" v-model="formValidate.date"></DatePicker>
                    </FormItem>
                </Col>
                <Col span="2" style="text-align: center">-</Col>
                <Col span="11">
                    <FormItem prop="time">
                        <TimePicker type="time" placeholder="Select time" v-model="formValidate.time"></TimePicker>
                    </FormItem>
                </Col>
            </Row>
        </FormItem>
        <FormItem label="Gender" prop="gender">
            <RadioGroup v-model="formValidate.gender">
                <Radio label="male">Male</Radio>
                <Radio label="female">Female</Radio>
            </RadioGroup>
        </FormItem>
        <FormItem label="Hobby" prop="interest">
            <CheckboxGroup v-model="formValidate.interest">
                <Checkbox label="Eat"></Checkbox>
                <Checkbox label="Sleep"></Checkbox>
                <Checkbox label="Run"></Checkbox>
                <Checkbox label="Movie"></Checkbox>
            </CheckboxGroup>
        </FormItem>
        <FormItem label="Desc" prop="desc">
            <Input v-model="formValidate.desc" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="Enter something..."></Input>
        </FormItem>
        <FormItem>
            <Button type="primary" @click="handleSubmit('formValidate')">Submit</Button>
            <Button @click="handleReset('formValidate')" style="margin-left: 8px">Reset</Button>
        </FormItem>
    </Form> -->
  </div>
</template>

<script>
import params from '../argu-page/params.vue'
export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      formValidate: {
        id: '',
        name: '',
        value: ''
      },
      ruleValidate: {
        name: [
          {
            required: true,
            message: '权限名称不能为空',
            trigger: 'blur'
          }
        ],
        value: [
          {
            required: true,
            message: '权限代码不能为空',
            trigger: 'blur'
          }
        ]
      }
      //   formValidate: {
      //     name: "",
      //     mail: "",
      //     city: "",
      //     gender: "",
      //     interest: [],
      //     date: "",
      //     time: "",
      //     desc: "",
      //   },
      //   ruleValidate: {
      //     name: [
      //       {
      //         required: true,
      //         message: "The name cannot be empty",
      //         trigger: "blur",
      //       },
      //     ],
      //     mail: [
      //       {
      //         required: true,
      //         message: "Mailbox cannot be empty",
      //         trigger: "blur",
      //       },
      //       { type: "email", message: "Incorrect email format", trigger: "blur" },
      //     ],
      //     city: [
      //       {
      //         required: true,
      //         message: "Please select the city",
      //         trigger: "change",
      //       },
      //     ],
      //     gender: [
      //       {
      //         required: true,
      //         message: "Please select gender",
      //         trigger: "change",
      //       },
      //     ],
      //     interest: [
      //       {
      //         required: true,
      //         type: "array",
      //         min: 1,
      //         message: "Choose at least one hobby",
      //         trigger: "change",
      //       },
      //       {
      //         type: "array",
      //         max: 2,
      //         message: "Choose two hobbies at best",
      //         trigger: "change",
      //       },
      //     ],
      //     date: [
      //       {
      //         required: true,
      //         type: "date",
      //         message: "Please select the date",
      //         trigger: "change",
      //       },
      //     ],
      //     time: [
      //       {
      //         required: true,
      //         type: "string",
      //         message: "Please select time",
      //         trigger: "change",
      //       },
      //     ],
      //     desc: [
      //       {
      //         required: true,
      //         message: "Please enter a personal introduction",
      //         trigger: "blur",
      //       },
      //       {
      //         type: "string",
      //         min: 20,
      //         message: "Introduce no less than 20 words",
      //         trigger: "blur",
      //       },
      //     ],
      //   },
    }
  },
  watch: {
    // columns (columns) {
    //   this.handleColumns(columns)
    // },
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
    },
    editData (editData) {
      this.formValidate.id = editData.id
      this.formValidate.name = editData.name
      this.formValidate.value = editData.value
    }
  },
  methods: {
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
  }
}
</script>
